import type { RouteLocation } from 'vue-router'
import { useAuthStore } from '@/stores/AuthStore'
import { useShiftStore } from '@/stores/ShiftStore'

export function shiftMiddleware(to: RouteLocation, from: RouteLocation) {
  const authStore = useAuthStore()
  if (!authStore.isPersonalDevice) return true

  const leavingShiftRoute =
    from.path.startsWith('/shift') && !to.path.startsWith('/shift')

  if (leavingShiftRoute) {
    useShiftStore().shifts.forEach((shift) => {
      useShiftStore().markShiftAsSeen(shift)
    })
  }

  return true
}
